<template>
  <div class="em-form-row">
    <slot />
  </div>
</template>

<style scoped>
.em-form-row {
  display: flex;
  flex-direction: row;
  gap: 32px;
  max-width: 100%;
}
</style>
